import React from 'react';
import { useStorageState } from 'react-storage-hooks';

const DataLayerLastCustomURL = () => {
  const [, setLastCustomUrl] = useStorageState<string>(sessionStorage, 'SEO.LAST_CUSTOM_URL', '');

  React.useEffect(() => {
    setLastCustomUrl('');
  }, [setLastCustomUrl]);

  return null;
};

export default DataLayerLastCustomURL;
